{% import CustomSelect from 'shared/components/select/select.monk' %}
<div class="sorting">
  <div class="sorting__title"> {{ title }} </div>
  <CustomSelect selectedId="{{ selectedId }}" options="{{ options }}" ids="{{ ids}}"/>
</div>